import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, white } = colors;

export const Container = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Image = styled.img``;

export const ItemDescription = styled.div`
  margin-left: 4px;
  font-size: 14px;

  p {
    display: inline-block;
    margin-bottom: 0;
    color: ${gray01};

    span {
      font-weight: 700;
      color: ${gray01};
    }
  }
`;
